export interface DatabasePreviewPannelProps {
  projectId: string;
  permissions: string[];
  onClose: () => void;
}

export interface ColumnInfo {
  name: string;
  type: string;
}

export interface TableRecordsResponse {
  columns: ColumnInfo[];
  rows: Record<string, any>[];
  total: number;
  page: number;
  page_size: number;
}

export interface QueryResponse {
  columns: string[];
  rows: Record<string, any>[];
  row_count: number;
  affected_rows?: number | null;
  status_message?: string | null;
}

export enum DatabasePreviewPannelMode {
  BROWSE = 'browse',
  QUERY = 'query',
}